import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  CardMedia,
  Button,
  Container,
} from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";

// Keyframes for fade-in + slide-up animation
// const fadeInUp = keyframes`
//   0% {
//     opacity: 0;
//     transform: translateY(20px);
//   }
//   100% {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// Styled Box with conditional animation
const AnimatedBox = styled(Box)(({ theme, isVisible }) => ({
  opacity: isVisible ? 1 : 0,
  transform: isVisible ? "translateY(0)" : "translateY(20px)",
  transition: "opacity 1s ease-out, transform 1s ease-out",
  [theme.breakpoints.up("md")]: {
    // You can add responsive animation delays or durations if needed
  },
}));

export default function CustomCard(props) {
  const [isVisible, setIsVisible] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When the element becomes visible
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optional: Unobserve once animation has triggered
          observer.unobserve(boxRef.current);
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
        rootMargin: "0px", // No margin
      }
    );

    if (boxRef.current) {
      observer.observe(boxRef.current);
    }

    // Cleanup
    return () => {
      if (boxRef.current) {
        observer.unobserve(boxRef.current);
      }
    };
  }, []);

  return (
    <Box
      sx={{
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 4 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fafafa",
      }}
    >
      <AnimatedBox ref={boxRef} isVisible={isVisible} sx={{ width: "90%" }}>
        <Card
          sx={{
            borderRadius: 2,
            boxShadow: 4,
            overflow: "hidden",
            display: "flex",
            backgroundColor: "#fafafa",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <CardContent
            sx={{
              flex: 1,
              p: { xs: 4, md: 6 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                textTransform: "uppercase",
                mb: 2,
                color: "#BF0A30", // Brand accent color
              }}
            >
              {props.title || "Card Title"}
            </Typography>

            <Divider
              sx={{
                width: 80,
                height: 4,
                mb: 3,
                backgroundColor: "#BF0A30",
                borderRadius: 2,
              }}
            />

            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "1rem", md: "1.25rem" },
                lineHeight: 1.8,
                color: "#444",
              }}
              dangerouslySetInnerHTML={{
                __html:
                  props.desc ||
                  "This is a placeholder description. Please provide the content.",
              }}
            />
            {props.buttonTitle && <Container
              maxWidth="md"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex",
                justifyContent: "center",
                textAlign: "center",
                paddingTop: "40px",
              }}
            >
              <Button
                component={Link}
                to={props.buttonLink || "/"}
                variant="contained"
                sx={{
                  backgroundColor: "#BF0A30",
                  "&:hover": { backgroundColor: "#a30d26" },
                  fontSize: { xs: "1rem", md: "1.25rem" },
                }}
              >
                {props.buttonTitle}
              </Button>
            </Container> }
          </CardContent>
          {props.image && (
            <CardMedia
              component="img"
              image={props.image}
              alt={props.title || "Card Image"}
              sx={{
                width: { xs: "100%", md: 500 },
                objectFit: "cover",
              }}
            />
          )}
        </Card>
      </AnimatedBox>
    </Box>
  );
}
